import { useQuery } from "@tanstack/react-query";
import { fetchUsers } from "../../api/users";

export const useFetchUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: fetchUsers,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    retry: false, // Disable retries on failure
    onError: (error) => {
      console.error("Error fetching users:", error);
    },
  });
}